import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';

@Injectable()
export class LoadingStateService {

  private loadingSubject: Subject<boolean> = new BehaviorSubject(false);

  constructor() {
  }

  public setLoading(value: boolean) {
    this.loadingSubject.next(value);
  }

  public get loadingState(): Observable<boolean> {
    return this.loadingSubject
      .scan((sum, value) => Math.max(0, (value) ? sum + 1 : sum - 1), 0)
      .map(value => value > 0);
  }

}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/shared/services/loading-state.service.ts